import ClientLoggerFactory from "../../../../logging/ClientLoggerFactory";
import { DataStore } from "aws-amplify";
import DataStoreWorkScopeSpecificationDAO from "./DataStoreWorkScopeSpecificationDAO";
import JSONDeserializerFactory from "../../../../util/data/serialization/JSONDeserializerFactory";
import JSONSerializerFactory from "../../../../util/data/serialization/JSONSerializerFactory";
import MockDataStoreWorkScopeSpecificationDAO from "./MockDataStoreWorkScopeSpecificationDAO";
import WorkScopeSpecificationDAO from "../WorkScopeSpecificationDAO";

export default class DataStoreWorkScopeSpecificationDAOFactory {
    private static readonly INSTANCE: DataStoreWorkScopeSpecificationDAO = new DataStoreWorkScopeSpecificationDAO(
        JSONSerializerFactory.getInstance(),
        JSONDeserializerFactory.getInstance(),
        DataStore,
        ClientLoggerFactory.getClientLogger("DataStoreWorkScopeSpecificationDAO")
    );
    private static readonly MOCK_INSTANCE: WorkScopeSpecificationDAO = new MockDataStoreWorkScopeSpecificationDAO(
        JSONSerializerFactory.getInstance(),
        JSONDeserializerFactory.getInstance(),
        DataStore,
        ClientLoggerFactory.getClientLogger("MockDataStoreWorkScopeSpecificationDAO")
    );

    public static getInstance(): WorkScopeSpecificationDAO {
        if (process.env.REACT_APP_MOCK_ENABLED === "true") {
            return this.MOCK_INSTANCE;
        } else {
            return this.INSTANCE;
        }
    }
}
